/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { PlayerControllerType } from "../../shared/types";

import { ShakaPlayerController } from "./ShakaPlayerController";
import { ControllerOptions, PlayerController } from "./types";
import { VideoJsPlayerController } from "./VideoJsPlayerController";

export const getController = (
  options: ControllerOptions,
  playerType?: PlayerControllerType,
): PlayerController => {
  switch (playerType) {
    case PlayerControllerType.VideoJsPlayer:
      return new VideoJsPlayerController(options);
    case PlayerControllerType.ShakaPlayer:
      return new ShakaPlayerController(options);
    default:
      throw new Error("Unsupported player controller type for custom player");
  }
};
